import React from "react";
import "./LoadingView.css";
export default class LoadingView extends React.Component {
  render() {
    //const { classes } = this.props;
    return (
      // <div className="loading">
      //     <div className="loader"></div>
      //     <span>Vui lòng chờ... đang tải dữ liệu</span>
      // </div>
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ height: 500 }}
      >
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
        <div className="ml-3">Đang tải dữ liệu...</div>
      </div>
    );
  }
}
